import { observer } from 'mobx-react';
import {
  useDrawsStore,
} from '@roc/feature-draws';
import { useEffect, useState } from 'react';
import { useDocumentStore } from '@roc/feature-documents';
import { Box, Grid, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Draw } from '../../types/draws';
import { getDrawNumber } from '../../utils/utils';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { TaskTodoCardCompponent, TodoItem } from '@roc/feature-loan-details';
import { LoanProcess } from '@roc/feature-utils';
import { DrawDocumentForms } from '../../drawDetails/drawDocumentForms';

interface LoanDrawsTodosProps {
  loanId: number;
  properties: any[];
}

export const LoanDrawsPendingTodos = observer(({ loanId, properties }: LoanDrawsTodosProps) => {
  const { drawStore } = useDrawsStore();
  const { documentStore } = useDocumentStore();
  const drawList = drawStore?.drawList || [];

  const loanDrawsTodosPending = documentStore.loanTodosStore.loanDrawsTodosPending || {};
  const isTodosEmpty = Object.keys(loanDrawsTodosPending).length === 0;

  useEffect(() => {
    documentStore.loanTodosStore.fetchLoanDrawTodosPending(loanId);
  }, [loanId, documentStore.loanTodosStore]);

  const getAccordionTitle = (drawTitle: string, todos: TodoItem[], drawList: Draw[]) => {
    if (todos.length === 0) {
      return `${drawTitle}`;
    }

    const drawNumber = todos.find(t => t.document)?.document?.drawId;

    if (!drawNumber) {
      return `${drawTitle}`;
    }

    const draw = drawList.find(draw => draw.drawId === drawNumber);

    if (!draw) {
      return `${drawTitle} - ${drawNumber}`;
    }

    return `${drawTitle} - ${drawNumber} - ${draw.propertyAddress}`;
  }

  useEffect(() => {
    const drawId = documentStore.currentDocument?.drawId;

    if (drawId) {
      drawStore.fetchDrawDTOById(`${drawId}`);
    }
  }, [documentStore, drawStore, documentStore.currentDocument])

  const drawId = documentStore.currentDocument?.drawId;

  return (
    <Box>
      {isTodosEmpty ? (
        <Box pt={3}>
          <Alert severity="success">
            You don't have any pending to-dos.
          </Alert>
        </Box>
      ) : (
        <>
          {Object.entries(loanDrawsTodosPending).map(([key, value]) => (
            <DrawAccordionSimplified key={key} title={getAccordionTitle(key, value, drawList)} >
              <Box width="100%">
                <TaskTodoCardCompponent
                  todos={value}
                  ccTodos={[]}
                  loanProcess={LoanProcess.DRAWS}
                  showSectionActions={false}
                  showFileName={false}
                  showActions={true}
                  isSummaryView={true}
                  useAccordion={false}
                />
              </Box>
            </DrawAccordionSimplified>)
          )}
          {!drawStore.isDrawDetailsModalOpen && (
            <DrawDocumentForms loanId={loanId} drawId={drawId} />
          )}
        </>

      )}
    </Box>
  );
});


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
      textDecoration: 'underline',
      marginLeft: theme.spacing(2),
    },
    summary: {
      backgroundColor: 'rgba(237, 237, 237, 1)',
      flexDirection: 'row-reverse',
      paddingLeft: theme.spacing(0),
    },
    details: {
      padding: 0,
    },
  }),
);


const DrawAccordionSimplified = observer(({ title, children }) => {
  const [expanded, setExpanded] = useState(true);
  const classes = useStyles();
  return (<Accordion
    expanded={expanded}
    onChange={(e, expanded) => setExpanded(expanded)}>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls="panel1a-content"
      className={classes.summary}
      id="panel1a-header"
    >
      <Grid container direction='row' spacing={2} justifyContent='space-between'>
        <Grid item>
          <Typography className={classes.heading}>{title}</Typography>
        </Grid>
      </Grid>
    </AccordionSummary>
    <AccordionDetails className={classes.details}>
      {children}
    </AccordionDetails>
  </Accordion>)
});